'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp, _dec2, _class3, _class4, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactFlexboxGrid = require('react-flexbox-grid');

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _components = require('../../components');

var _AppFooter = require('./AppFooter.css');

var _AppFooter2 = _interopRequireDefault(_AppFooter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AppFooterLink = (_dec = (0, _reactCssModules2.default)(_AppFooter2.default), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(AppFooterLink, _Component);

  function AppFooterLink(props) {
    (0, _classCallCheck3.default)(this, AppFooterLink);
    return (0, _possibleConstructorReturn3.default)(this, (AppFooterLink.__proto__ || (0, _getPrototypeOf2.default)(AppFooterLink)).call(this, props));
  }

  (0, _createClass3.default)(AppFooterLink, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          url = _props.url,
          title = _props.title;
      //

      return _react2.default.createElement(
        'div',
        { styleName: 'af-footer-link-out' },
        _react2.default.createElement(
          _components.Link,
          {
            to: url,
            title: title
          },
          _react2.default.createElement(
            'div',
            { styleName: 'af-footer-link-in' },
            title
          )
        )
      );
    }
  }]);
  return AppFooterLink;
}(_react.Component), _class2.propTypes = {
  url: _react.PropTypes.string.isRequired,
  title: _react.PropTypes.string.isRequired
}, _temp)) || _class);
var AppFooter = (_dec2 = (0, _reactCssModules2.default)(_AppFooter2.default), _dec2(_class3 = (_temp2 = _class4 = function (_Component2) {
  (0, _inherits3.default)(AppFooter, _Component2);

  function AppFooter(props) {
    (0, _classCallCheck3.default)(this, AppFooter);

    var _this2 = (0, _possibleConstructorReturn3.default)(this, (AppFooter.__proto__ || (0, _getPrototypeOf2.default)(AppFooter)).call(this, props));

    _this2.state = {
      hideSiteMap: _this2.props.hideSiteMap || false,
      environmentIssueRoutes: [[_config2.default.routes.issueFossilFuels, 'Fossil fuels'], [_config2.default.routes.issueDeforestation, 'Deforestation']],
      socialIssueRoutes: [[_config2.default.routes.issueGenderEquality, 'Gender equality'], [_config2.default.routes.issueCivilianFirearms, 'Civilian firearms'], [_config2.default.routes.issuePrisonIndustrialComplex, 'Prison industrial complex'], [_config2.default.routes.issueArmsManufacturers, 'Arms manufacturers'], [_config2.default.routes.issueTobacco, 'Tobacco']],
      solutionRoutes: [[_config2.default.routes.solutionOfferSustainability, 'Offer sustainable investments'], [_config2.default.routes.solutionDefaultSustainability, 'Make the default investment sustainable']],
      dataRoutes: [[_config2.default.routes.plans, 'Retirement plans'], [_config2.default.routes.targetDateFunds, 'Target date funds'], [_config2.default.routes.mutualFundsETFs, 'Mutual funds and ETFs'], [_config2.default.routes.assetManagers, 'Asset managers'], [_config2.default.routes.companies, 'Companies'], [_config2.default.routes.howitworks, 'Methodology']],
      eduCenterRoutes: [[_config2.default.routes.eduCenterFinRisks, 'Financial risks of unsustainable investments'],
      // [config.routes.eduCenterEnvSocRisks, 'Environmental and social risks of unsustainable investments'],
      [_config2.default.routes.eduCenterIndividual, 'For employees'], [_config2.default.routes.eduCenterPlanAdmins, 'For plan administrators'],
      // [config.routes.eduCenterIndProfs, 'For financial industry professionals'],
      [_config2.default.routes.faqs, 'FAQs']]
    };
    return _this2;
  }

  (0, _createClass3.default)(AppFooter, [{
    key: 'render',
    value: function render() {
      var _state = this.state,
          environmentIssueRoutes = _state.environmentIssueRoutes,
          socialIssueRoutes = _state.socialIssueRoutes,
          solutionRoutes = _state.solutionRoutes,
          dataRoutes = _state.dataRoutes,
          eduCenterRoutes = _state.eduCenterRoutes,
          hideSiteMap = _state.hideSiteMap;


      var aysLogo = require('../../../static/images/AsYouSow_Logo_color.svg');

      //
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { styleName: 'af-img-bckgrnd' },
          _react2.default.createElement(
            _components.ContainerDivs,
            null,
            hideSiteMap ? _react2.default.createElement('div', { styleName: 'af-row0-buffer' }) : _react2.default.createElement(
              'nav',
              { styleName: 'af-row0' },
              _react2.default.createElement(
                _reactFlexboxGrid.Row,
                null,
                _react2.default.createElement(
                  _reactFlexboxGrid.Col,
                  { xs: 12, md: 4 },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'af-links-label' },
                    _react2.default.createElement(
                      _components.Link,
                      {
                        to: _config2.default.routes.issues,
                        title: 'The issues'
                      },
                      'The issues'
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'af-links-wrap' },
                    _react2.default.createElement(
                      'div',
                      { styleName: 'af-links-sublabel' },
                      'Environment'
                    ),
                    environmentIssueRoutes.map(function (e, i) {
                      var _e = (0, _slicedToArray3.default)(e, 2),
                          url = _e[0],
                          title = _e[1];

                      return _react2.default.createElement(AppFooterLink, {
                        key: 'footer-links-1-' + i,
                        url: url,
                        title: title
                      });
                    }),
                    _react2.default.createElement(
                      'div',
                      { styleName: 'af-links-sublabel' },
                      'Social'
                    ),
                    socialIssueRoutes.map(function (e, i) {
                      var _e2 = (0, _slicedToArray3.default)(e, 2),
                          url = _e2[0],
                          title = _e2[1];

                      return _react2.default.createElement(AppFooterLink, {
                        key: 'footer-links-1-' + i,
                        url: url,
                        title: title
                      });
                    })
                  )
                ),
                _react2.default.createElement(
                  _reactFlexboxGrid.Col,
                  { xs: 12, md: 4 },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'af-links-label' },
                    _react2.default.createElement(
                      _components.Link,
                      {
                        to: _config2.default.routes.solutions,
                        title: 'The solutions'
                      },
                      'The solutions'
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'af-links-wrap' },
                    solutionRoutes.map(function (e, i) {
                      var _e3 = (0, _slicedToArray3.default)(e, 2),
                          url = _e3[0],
                          title = _e3[1];

                      return _react2.default.createElement(AppFooterLink, {
                        key: 'footer-links-2-' + i,
                        url: url,
                        title: title
                      });
                    })
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'af-links-label' },
                    _react2.default.createElement(
                      _components.Link,
                      {
                        to: _config2.default.routes.data,
                        title: 'The data'
                      },
                      'The data'
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'af-links-wrap' },
                    dataRoutes.map(function (e, i) {
                      var _e4 = (0, _slicedToArray3.default)(e, 2),
                          url = _e4[0],
                          title = _e4[1];

                      return _react2.default.createElement(AppFooterLink, {
                        key: 'footer-links-3-' + i,
                        url: url,
                        title: title
                      });
                    })
                  )
                ),
                _react2.default.createElement(
                  _reactFlexboxGrid.Col,
                  { xs: 12, md: 4 },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'af-links-label' },
                    _react2.default.createElement(
                      _components.Link,
                      {
                        to: _config2.default.routes.eduCenter,
                        title: 'Action center'
                      },
                      'Action center'
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'af-links-wrap' },
                    eduCenterRoutes.map(function (e, i) {
                      var _e5 = (0, _slicedToArray3.default)(e, 2),
                          url = _e5[0],
                          title = _e5[1];

                      return _react2.default.createElement(AppFooterLink, {
                        key: 'footer-links-4-' + i,
                        url: url,
                        title: title
                      });
                    })
                  )
                )
              )
            ),
            _react2.default.createElement(_components.SignupForm, null),
            _react2.default.createElement(
              'div',
              { styleName: 'af-row1' },
              _react2.default.createElement(
                _reactFlexboxGrid.Row,
                null,
                _react2.default.createElement(
                  _reactFlexboxGrid.Col,
                  { xs: 12, md: 4 },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'af-col-in' },
                    _react2.default.createElement(
                      'div',
                      { styleName: 'af-col-hl' },
                      _react2.default.createElement(
                        _components.Link,
                        {
                          to: '/about',
                          title: 'About us'
                        },
                        'Invest your values'
                      )
                    ),
                    _react2.default.createElement(
                      'p',
                      { styleName: 'af-col-p' },
                      'We offer sustainable investment tools that highlight issues dealing with climate change, gender equality and more'
                    ),
                    _react2.default.createElement(
                      'p',
                      { styleName: 'af-col-p' },
                      _react2.default.createElement(
                        _components.Link,
                        {
                          to: _config2.default.routes.about,
                          title: 'About Invest Your Values',
                          transparentbutton: true
                        },
                        _react2.default.createElement(
                          'span',
                          { styleName: 'nowrap' },
                          'About us',
                          _react2.default.createElement(_components.LinkIcon, null)
                        )
                      )
                    )
                  )
                ),
                _react2.default.createElement(
                  _reactFlexboxGrid.Col,
                  { xs: 12, md: 4 },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'af-col-in' },
                    _react2.default.createElement(
                      'div',
                      { styleName: 'af-col-hl' },
                      _react2.default.createElement(
                        _components.Link,
                        {
                          to: _config2.default.links.donate,
                          title: 'Support this work'
                        },
                        'Support this work'
                      )
                    ),
                    _react2.default.createElement(
                      'p',
                      { styleName: 'af-col-p' },
                      'Invest Your Values is funded by contributions to ',
                      _react2.default.createElement(
                        'span',
                        { styleName: 'nowrap' },
                        'As You Sow'
                      ),
                      ', a ',
                      _react2.default.createElement(
                        'span',
                        { styleName: 'nowrap' },
                        'non-profit 501(c)3'
                      ),
                      '.'
                    ),
                    _react2.default.createElement(
                      'p',
                      { styleName: 'af-col-p' },
                      _react2.default.createElement(
                        _components.Link,
                        {
                          to: _config2.default.links.donate,
                          title: 'Donate to As You Sow',
                          transparentdonatebutton: true
                        },
                        'Donate',
                        _react2.default.createElement(_components.LinkIcon, null)
                      )
                    )
                  )
                ),
                _react2.default.createElement(
                  _reactFlexboxGrid.Col,
                  { xs: 12, md: 4 },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'af-col-in' },
                    _react2.default.createElement(
                      'div',
                      { styleName: 'af-col-hl' },
                      _react2.default.createElement(
                        _components.Link,
                        {
                          to: _config2.default.links.ays,
                          title: 'As You Sow'
                        },
                        _react2.default.createElement('img', {
                          src: aysLogo,
                          alt: 'As You Sow',
                          styleName: 'af-logo'
                        }),
                        _react2.default.createElement(
                          _components.SrOnly,
                          null,
                          'As You Sow'
                        )
                      )
                    ),
                    _react2.default.createElement(
                      'p',
                      { styleName: 'af-col-p' },
                      'Invest Your Values  is a project by ',
                      _react2.default.createElement(
                        'i',
                        null,
                        'As You Sow'
                      ),
                      ', a 501(c)3 nonprofit empowering shareholders to change corporations for good'
                    ),
                    _react2.default.createElement(
                      'p',
                      { styleName: 'af-col-p' },
                      _react2.default.createElement(
                        _components.Link,
                        {
                          to: _config2.default.links.ays,
                          title: 'As You Sow',
                          transparentbutton: true
                        },
                        _react2.default.createElement(
                          'span',
                          { styleName: 'nowrap' },
                          'Visit As You Sow',
                          _react2.default.createElement(_components.LinkIcon, null)
                        )
                      )
                    )
                  )
                )
              )
            ),
            _react2.default.createElement(
              'div',
              { styleName: 'af-row2' },
              _react2.default.createElement(
                _reactFlexboxGrid.Row,
                null,
                _react2.default.createElement(
                  _reactFlexboxGrid.Col,
                  { xs: 12, md: 8 },
                  _react2.default.createElement(
                    'div',
                    { styleName: 'af-col-hl' },
                    _react2.default.createElement(
                      _components.Link,
                      {
                        to: _config2.default.routes.legal,
                        title: 'Legal'
                      },
                      'Legal'
                    ),
                    ' \xA0\xA0\xA0'
                  ),
                  _react2.default.createElement(
                    'div',
                    { styleName: 'af-col-p' },
                    '\xA9 Copyright ',
                    new Date().getFullYear(),
                    ' As You Sow. All rights reserved.',
                    _react2.default.createElement('br', null),
                    'Main Post Office, PO Box 751, Berkeley, CA 94701'
                  )
                ),
                _react2.default.createElement(
                  _reactFlexboxGrid.Col,
                  { xs: 12, md: 4 },
                  _react2.default.createElement(
                    'p',
                    { styleName: 'af-col-hl' },
                    _react2.default.createElement(
                      'i',
                      null,
                      'Connect with As You Sow'
                    )
                  ),
                  _react2.default.createElement(
                    'p',
                    { styleName: 'af-col-p' },
                    _react2.default.createElement(
                      _components.Link,
                      {
                        to: _config2.default.links.contact,
                        title: 'Contact us'
                      },
                      'Contact us'
                    ),
                    '\xA0\xA0\xA0',
                    _react2.default.createElement(
                      _components.Link,
                      {
                        to: _config2.default.links.socialAYStwitter,
                        title: 'Connect with us on Twitter',
                        xstrong: true
                      },
                      _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-twitter' })
                    ),
                    '\xA0\xA0\xA0',
                    _react2.default.createElement(
                      _components.Link,
                      {
                        to: _config2.default.links.socialAYSfb,
                        title: 'Connect with us on Facebook',
                        xstrong: true
                      },
                      _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-facebook-official' })
                    )
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);
  return AppFooter;
}(_react.Component), _class4.propTypes = {
  hideSiteMap: _react.PropTypes.bool
}, _temp2)) || _class3);
exports.default = AppFooter;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/AppFooter/AppFooter.js
// module id = 1375
// module chunks = 0